const API_BASE = import.meta.env.VITE_API_BASE || '/api'

export function getToken() {
  return localStorage.getItem('token')
}

export function getUserId() {
  return localStorage.getItem('user_id')
}

export function setAuth(token, userId) {
  localStorage.setItem('token', token)
  localStorage.setItem('user_id', String(userId))
}

export function clearAuth() {
  localStorage.removeItem('token')
  localStorage.removeItem('user_id')
}

export async function api(path, { method = 'GET', body } = {}) {
  const headers = { 'Content-Type': 'application/json' }
  const token = getToken()
  if (token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  if (res.status === 401) {
    clearAuth()
    if (!window.location.hash.includes('/login')) {
      window.location.hash = '#/login'
    }
    throw new Error('請重新登入')
  }

  if (!res.ok) {
    let detail = '發生錯誤，請再試一次'
    try {
      const data = await res.json()
      if (typeof data.detail === 'string' || typeof data.detail === 'number') {
        detail = data.detail
      } else if (Array.isArray(data.detail) && data.detail.length) {
        const first = data.detail[0]
        detail = first?.msg || JSON.stringify(first)
      } else if (data.detail && typeof data.detail === 'object') {
        detail = data.detail.msg || JSON.stringify(data.detail)
      }
    } catch {
      // 忽略解析失敗
    }
    throw new Error(detail)
  }
  return res.json()
}
